var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTitle', {
    attrs: {
      "title": "Обработка заявлений"
    }
  })], 1), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-y": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "white--text px-4",
          attrs: {
            "small": "",
            "rounded": "",
            "outlined": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-plus")]), _vm._v(" Создать заявление ")], 1)];
      }
    }])
  }, [_c('v-list', _vm._l(_vm.dictionaries.applicationTypeActual, function (item, index) {
    return _c('v-list-item', {
      key: index,
      attrs: {
        "disabled": _vm.disabledListItem(item)
      },
      on: {
        "click": function click($event) {
          return _vm.openDialog(item);
        }
      }
    }, [_c('v-list-item-title', [_vm._v(_vm._s(item.name))])], 1);
  }), 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('PageTable', {
    attrs: {
      "table-loading": _vm.tableLoading,
      "table-headers": _vm.tableHeaders,
      "table-items": _vm.applications.list,
      "filter": _vm.checkRoles,
      "custom-sort": _vm.sortFunc,
      "show-select": _vm.checkRoles,
      "value": _vm.selectedItem,
      "table-height": "284"
    },
    on: {
      "get-data": _vm.getApplications,
      "input": _vm.select
    },
    scopedSlots: _vm._u([{
      key: "button",
      fn: function fn() {
        var _vm$selectedItem, _vm$selectedItem3, _vm$selectedItem4;

        return [_vm.checkRoles ? _c('v-badge', {
          attrs: {
            "bordered": "",
            "color": (_vm$selectedItem = _vm.selectedItem) !== null && _vm$selectedItem !== void 0 && _vm$selectedItem.length ? 'red' : 'grey',
            "overlap": "",
            "disabled": true
          },
          scopedSlots: _vm._u([{
            key: "badge",
            fn: function fn() {
              var _vm$selectedItem2;

              return [_c('span', [_vm._v(_vm._s(((_vm$selectedItem2 = _vm.selectedItem) === null || _vm$selectedItem2 === void 0 ? void 0 : _vm$selectedItem2.length) || 0))])];
            },
            proxy: true
          }], null, false, 3722279087)
        }, [_c('v-btn', {
          attrs: {
            "depressed": "",
            "outlined": "",
            "rounded": "",
            "small": "",
            "color": "red",
            "disabled": !((_vm$selectedItem3 = _vm.selectedItem) !== null && _vm$selectedItem3 !== void 0 && _vm$selectedItem3.length)
          },
          on: {
            "click": function click($event) {
              _vm.isRemovedItem = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-trash-can-outline")]), _vm._v(" Удалить ")], 1)], 1) : _vm._e(), _vm.checkRoles ? _c('v-btn', {
          staticClass: "ml-4",
          attrs: {
            "depressed": "",
            "outlined": "",
            "rounded": "",
            "small": "",
            "color": "red",
            "disabled": !!((_vm$selectedItem4 = _vm.selectedItem) !== null && _vm$selectedItem4 !== void 0 && _vm$selectedItem4.length)
          },
          on: {
            "click": function click($event) {
              _vm.isRemovedItem = true;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-trash-can-outline")]), _vm._v(" Удалить всё ")], 1) : _vm._e(), _c('v-badge', {
          attrs: {
            "overlap": "",
            "dot": "",
            "value": !!_vm.checkFilterProperties(_vm.applicationsFilter)
          }
        }, [_vm.checkRoles ? _c('v-btn', {
          staticClass: "white--text ml-4 filter-btn",
          attrs: {
            "small": "",
            "rounded": "",
            "outlined": "",
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              _vm.showFilter = !_vm.showFilter;
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "left": "",
            "small": ""
          }
        }, [_vm._v("mdi-filter-outline")]), _c('span', [_vm._v(_vm._s(_vm.showFilter ? 'Закрыть' : 'Фильтр'))])], 1) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "item.applicationStatus.name",
      fn: function fn(_ref2) {
        var _item$applicationStat, _item$applicationStat2;

        var item = _ref2.item;
        return [_c('span', {
          class: {
            'font-weight-bold': ((_item$applicationStat = item.applicationStatus) === null || _item$applicationStat === void 0 ? void 0 : _item$applicationStat.id) === 2
          }
        }, [_vm._v(" " + _vm._s((_item$applicationStat2 = item.applicationStatus) === null || _item$applicationStat2 === void 0 ? void 0 : _item$applicationStat2.name) + " ")])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var _item$applicationStat3, _item$applicationStat4;

        var item = _ref3.item;
        return [!_vm.checkRoles ? _c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Отправить заявление",
            "disabled": ![1, 3].includes((_item$applicationStat3 = item.applicationStatus) === null || _item$applicationStat3 === void 0 ? void 0 : _item$applicationStat3.id)
          },
          on: {
            "click": function click($event) {
              return _vm.openSendDialog(item);
            }
          }
        }, [_vm._v(" mdi-send ")]) : _vm._e(), _c('v-icon', {
          staticClass: "mr-2 eye-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Просмотр"
          },
          on: {
            "click": function click($event) {
              return _vm.show(item);
            }
          }
        }, [_vm._v(" mdi-eye-outline ")]), !_vm.checkRoles ? [item.message ? _c('v-icon', {
          staticClass: "mr-1",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Сообщение"
          }
        }, [_vm._v(" " + _vm._s(item.message && item.unreadNotifications ? 'mdi-email-outline' : 'mdi-email-open-outline') + " ")]) : _vm._e(), _c('v-icon', {
          staticClass: "mr-1 edit-btn",
          class: {
            'mdi-loading': _vm.copyLoading
          },
          attrs: {
            "color": "lightGrey",
            "disabled": ![1, 3].includes((_item$applicationStat4 = item.applicationStatus) === null || _item$applicationStat4 === void 0 ? void 0 : _item$applicationStat4.id) || _vm.copyLoading,
            "size": "22",
            "title": "Редактировать"
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.copyLoading ? 'mdi-loading' : 'mdi-pencil-outline') + " ")]), _c('v-icon', {
          staticClass: "mr-1 remove-btn",
          attrs: {
            "color": "lightGrey",
            "size": "22",
            "title": "Удалить"
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-trash-can-outline ")])] : _vm._e()];
      }
    }])
  })], 1), _c('transition', {
    attrs: {
      "name": "curator-filter"
    }
  }, [_c('AppFilter', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFilter,
      expression: "showFilter"
    }],
    attrs: {
      "application-filter": _vm.applicationsFilter,
      "width-filter": "1200",
      "top": "255",
      "right": "29"
    },
    on: {
      "applyFilter": _vm.applyFilter,
      "closeFilter": function closeFilter($event) {
        _vm.showFilter = false;
      }
    }
  })], 1), _c('ApplicationCreateDialog', {
    attrs: {
      "dialog": _vm.dialog,
      "item": _vm.application
    },
    on: {
      "set-application": _vm.setApplication,
      "close-dialog": _vm.closeDialog
    }
  }), _c('ConfirmDelete', {
    attrs: {
      "dialog": _vm.removeDialog || _vm.isRemovedItem,
      "loading": _vm.buttonLoading,
      "message": _vm.messageForConfirmDelete
    },
    on: {
      "confirm": _vm.confirm,
      "closeModal": _vm.closeDialog
    }
  }), _c('SendDialog', {
    attrs: {
      "dialog": _vm.sendDialog,
      "loading": _vm.sendLoading,
      "print-loading": _vm.printLoading
    },
    on: {
      "get-print": _vm.getPrint,
      "confirm": _vm.send,
      "closeDialog": _vm.closeSendDialogDialog
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }